import {DeviceInfoDto} from './DeviceInfoDto';
import {WebSocketMessage} from './WebSocketMessage';
import {MessageAttachment} from './MessageAttachment';
import {
    InputSourceType
} from 'botato-botengine-browser/botato/botato-botengine/source/InstantMessagingAdapter/WebSocket/dto/InputSourceType.js';


export class WebSocketClientRequestDto extends WebSocketMessage {
    constructor(
        public message: string,
        deviceInfo: DeviceInfoDto,
        language: string,
        clientId: string,
        botId: string,
        inputSource?: InputSourceType,
        authToken?: string,
        // The web widget supports a single attachment, sent together with the message text.
        public attachments?: MessageAttachment[]
    ) {
        super(language, clientId, botId, {deviceInfo: deviceInfo}, inputSource, authToken);
    }
}
